
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { LoginFormProvider } from '@/components/auth/LoginFormContext';
import LoginForm from '@/components/auth/LoginForm';
import { User } from '@/types/userRole';

const SaasLogin: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (user: User) => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-6">
        <h1 className="text-4xl font-bold text-primary-blue">SaaS Platform Login</h1>
        <p className="text-gray-600 mt-2">Access your referral management dashboard</p>
      </div>
      
      <div className="max-w-md w-full">
        <Card className="border-0 shadow-xl bg-white/90 backdrop-blur-sm">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-center">Log in to your account</CardTitle>
            <CardDescription className="text-center">Enter your credentials to continue</CardDescription>
          </CardHeader>
          <CardContent>
            <LoginFormProvider 
              redirectPath="/dashboard" 
              onLoginSuccess={handleLoginSuccess}
              isSaasInstance={true}
            >
              <LoginForm isSaasInstance={true} />
            </LoginFormProvider>
          </CardContent>
        </Card>
        
        <div className="text-center mt-6">
          <p className="text-sm text-gray-600">
            Don't have an account?{' '}
            <a 
              href="/saas-signup" 
              className="font-medium text-primary hover:text-primary/90 transition-colors"
            >
              Sign up
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SaasLogin;
